module.exports = __webpack_public_path__ + "media/video-custom.3acc0341.mp4";